import BaseListStore from 'stores/BaseListStore';
import AvExclusionStore, { IAvExclusion } from 'stores/avExclusion/AvExclusionStore';
import { destroy, get, getPage, getCount, post, patch } from 'stores/_services/dataService';
import { getConditions } from 'stores/_services/filterService';
import { IDataFetchOptions } from '../../types';
import { runInAction } from 'mobx';

const SEARCH_FIELDS = ['path'];

const DEFAULT_FILTER = { path: '' };
const INTERNAL_FILTER = { type: { nlike: '%-internal' } };

export default class AvExclusionListStore extends BaseListStore<AvExclusionStore> {
    constructor() {
        super({
            itemStore: AvExclusionStore,
            defaultFilter: DEFAULT_FILTER
        });
    }

    async getAvExclusions(args: IDataFetchOptions = {}, pageNumber = 1, pageSize = 25): Promise<void> {
        const shouldReset = this._updateListState(args);
        let conditions = getConditions(this.filter) || [];
        conditions.push(INTERNAL_FILTER);

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                order: this.sort,
                limit: pageSize,
                skip: (pageNumber - 1) * pageSize,
                where: conditions
            }
        };

        const { data } = await getPage('avExclusions', options);
        const totalCount = await getCount('avExclusions', { where: conditions, searchFields: SEARCH_FIELDS });

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, 0);
        // every step that updates observables in an asynchronous process
        // should be marked as action(one way to use is runInAction),
        // only synchronous changes to observable data works in actions
        runInAction(() => {
            this.count = data.length;
            this.totalCount = totalCount;
            this.page = pageNumber;
            this.pageSize = pageSize;
        });
    }

    async create(avExclusion: IAvExclusion): Promise<void> {
        const payload = {
            path: avExclusion.path,
            type: avExclusion.type
        };

        return post('avExclusions/upsertAvExclusion', payload);
    }

    async delete(avExclusionId: string): Promise<void> {
        await destroy(`avExclusions/${avExclusionId}`);
    }
}
